import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { Provider } from 'react-redux'
import 'core-js/es7/object'
import 'core-js/es6/array'
import './axiosConf'

// components
import ElevateSecurity from './scenes'
import store from './store'

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: () => (
    <Provider store={store}>
      <ElevateSecurity />
    </Provider>
  ),
  domElementGetter
})

export const bootstrap = [reactLifecycles.bootstrap]

export const mount = [reactLifecycles.mount]

export const unmount = [reactLifecycles.unmount]

function domElementGetter() {
  // This is where single-spa will mount our application
  return document.getElementById('root')
}
